import _ from "lodash";
import columntypes from "./columntypes";
import contextoptions from "./contextoptions";
import eventbus from "./eventbus";
import reset from "./reset";

/**
 * reads the buffer and returns the content as base 64
 * @param {Buffer} buffer
 */
function arrayBufferToBase64(buffer) {
  var binary = "";
  var bytes = new Uint8Array(buffer);
  var len = bytes.byteLength;
  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

/**
 * Searches for an ID object in the given array with the given id
 * @param {Array} arr  the given array
 * @param {String} id the given id
 */
function getObjectById(arr = [], id = "") {
  const filtered = arr.filter(a => a.id === id);
  if (filtered.length) {
    return filtered[0];
  }
  return null;
}

function removeFromArrayById(arr = [], id = "") {
  return arr.filter(a => a.id !== id);
}

function getErrorMessage(e) {
  return _.get(e, "response.data.message", e.message || "UNKNOWN ERROR");
}

export default {
  arrayBufferToBase64,
  columntypes,
  contextoptions,
  copy: obj => {
    return JSON.parse(JSON.stringify(obj));
  },
  eventbus,
  getErrorMessage,
  getObjectById,
  removeFromArrayById,
  reset
};
